<div class="page-container">
  <mat-card class="container">
    <h2 class="header">PLANNED MAINTENANCE FOR DEVICE(S)</h2>
    <h4 class="devices">DEVICE(S) NAME</h4>
    <form [formGroup]="PM_Form" (ngSubmit)="onSubmit()">
      <div>
        <div class="selected-data-display">
          <div *ngIf="deviceNames.length == 0; then errorBlock else showBlock"></div>
          <ng-template #errorBlock><p class="error">Please add device(s) for Planned Maintenance</p></ng-template>
          <ng-template #showBlock>{{deviceNames}}</ng-template>
        </div>
 
        <div class="date-fields">
            <div class="form-field-container">
            <div class="compact-form-field">
          <mat-form-field appearance="outline">
              <mat-label class="label">PM Start Date ({{siteTimezone}})</mat-label>
              <input matInput readonly [matDatepicker]="picker" formControlName="start_date"
                class="form-control" (dateChange)="onStartDatechange($event)"
                autocomplete="off" [min]="timeZoneData" formControlName="start_date" class="date-input bgNone">
                <mat-hint>MM-DD-YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
            </div>
            <div class="compact-form-field">
              <input type="time" formControlName="start_time" (change)="onStartTimeChange($event)" [min]="timeData" class="form-control date-input">
            </div>
            </div>
          <div class="form-field-container">
          <div class="compact-form-field">  
        <mat-form-field appearance="outline" class="mrAuto">
            <mat-label class="label">PM End Date ({{siteTimezone}})</mat-label>
            <input matInput readonly [matDatepicker]="picker1"
              autocomplete="off" class="form-control" (dateChange)="onEndDatechange($event)" formControlName="end_date"
              [min]="minPmend" class="form-control date-input" class="bgNone">
            <mat-hint>MM-DD-YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
          </div>
          <div class="compact-form-field">
            <input type="time" formControlName="end_time" (change)="onEndTimeChange($event)" [min]="selectedStartTime" class="form-control date-input">
          </div>
          </div>
        </div>

        <h4 class="reason">REASON</h4>
        <mat-form-field class="full-width" appearance="outline">
          <mat-select placeholder="Choose a reason" formControlName="reason" (selectionChange)="changeReason($event)">
            <mat-option *ngFor="let reason of Reason" [value]="reason">{{ reason }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

        <div *ngIf="isSelectedReasonOther()">
          <mat-form-field class="full-width" appearance="outline">
            <textarea matInput placeholder="Add Custom reason" formControlName="otherReason" maxlength="100"></textarea>
            <mat-error>Please Enter a Reason</mat-error>
          </mat-form-field>
        </div>

      <div class="action-buttons">
        <button mat-raised-button color="warn" class="back" (click)="back()">BACK</button>
        <button mat-raised-button color="primary" class="submit-button submit" [disabled]="!PM_Form.valid || !deviceNames.length">SUBMIT</button>
      </div>
    </form>
  </mat-card>
</div>
